import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {LicenseState} from '../../../../services/licensing.interfaces';
import {LicensingTierTemplate} from '../../interface/licensingTier.interface';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {LicensingRenewalDialogComponent} from '../../licensing-renewal-dialog.component';
import {BaseLicensingInfoComponent} from '../base-licensing-info/base-licensing-info.component';
import {DatePipe} from '@angular/common';
import {AppUser, AuthService} from 'src/app/core/modules/auth/services/auth.service';
import {LocalStorageService} from '../../../../../../core/localStorage/local-storage.service';
import {TrialLimitsComponent} from '../../../trial-limits/trial-limits.component';
import {CustomerService} from '../../../../../../core/modules/auth/services/customer.service';

@Component({
  selector: 'app-trial-licensing-info',
  templateUrl: './trial-licensing-info.component.html',
  styleUrls: ['../../licensing-renewal-dialog.component.scss']
})
export class TrialLicensingInfoComponent extends BaseLicensingInfoComponent implements OnInit, LicensingTierTemplate {

  @Input() data: {
    licenseState: LicenseState;
    activeUser: AppUser;
    dialogRef: MatDialogRef<LicensingRenewalDialogComponent>;
  };

  @ViewChild('trialLimitsButton') public button: ElementRef;

  constructor( public datePipe: DatePipe,
               public localStorageService: LocalStorageService,
               public authService: AuthService,
               public dialog: MatDialog,
               public customerService: CustomerService) {
    super( datePipe,localStorageService, authService, customerService);
  }


  ngOnInit(): void {
    this.sourceData = this.data;
    super.ngOnInit();
    this.checkMuteStatus();
    this.buildTemplateData(this.sourceData.licenseState);
  }

  buildTemplateData(licenseState: LicenseState): void{

    const expiryPrefix = `Your trial license for ${licenseState.license.domain}`;
    let expiryMessage = '';
    if (licenseState.expiresIn < 0) {
      expiryMessage = `${expiryPrefix} has expired`;
    }
    if (licenseState.expiresIn === 0) {
      expiryMessage = `${expiryPrefix} expires today`;
    }
    if (licenseState.expiresIn === 1) {
      expiryMessage = `${expiryPrefix} expires in 1 day`;
    }

    if (licenseState.expiresIn > 1) {
      expiryMessage = `${expiryPrefix} will expire in ${licenseState.expiresIn} days`;
    }

    if(licenseState.bundle === 'ait-atu') {
      expiryMessage += ' as part of your <b>Admin Tools Unlimited</b> subscription.';
    } else {
      expiryMessage += '.';
    }

    this.templateData = {
      domain: licenseState.license.domain,
      expireDays: licenseState.expiresIn,
      expireDate: this.datePipe.transform(licenseState.license.subscriptions['ait-lsp'].expiry, 'MM/dd/yyyy'),
      expiryMessage,
      showIcon: (licenseState.expiresIn <= 7),
      plan: 'trial'
    };

  }

  showTrialLimits(): void {
    this.dialog.open(TrialLimitsComponent, {
      panelClass: 'ait-tight-panel',
      hasBackdrop: true,
      disableClose: false,
      height: '180px',
      width: '620px',
      data: { positionRelativeToElement: this.button }
    });
  }

}
